import React from 'react'
import { Label, TxtLink } from 'atoms/Texts'
import { FormMail, FormPass } from 'atoms/Inputs'
import { ButtonReg } from 'atoms/Buttons'
import { PassRow, EmailRow, BtnRow, PassRefRow, WarningRow } from './styles'
import { withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components'

import { ROUTE_AUTH_FORGOT_PASS } from 'fixtures/routes'

const LoginForm = props => {
  const {
    fnOnChange,
    fnOnSubmit,
    btnLabel,
    isBtnDisabled,
    theme,
    history: { push },
    match: { path }
  } = props

  const navToForgot = () => {
    const pathway = path.split('login')[0]
    push(`${pathway}${ROUTE_AUTH_FORGOT_PASS}`)
  }

  return (
    <div>
      <form onSubmit={fnOnSubmit}>
        <EmailRow>
          <Label>Email</Label>
          <FormMail onChangeVal={e => fnOnChange(e.target.value, 'username')} width={'100%'} />
        </EmailRow>
        <PassRow>
          <Label>Password</Label>
          <FormPass onChangeVal={e => fnOnChange(e.target.value, 'password')} width={'100%'} />
        </PassRow>
        <PassRefRow>
          <TxtLink href={'#'} onClick={navToForgot}>Forgot Password?</TxtLink>
        </PassRefRow>
        <BtnRow>
          <ButtonReg
            btnTxt={btnLabel}
            disabled={isBtnDisabled}
            onClick={fnOnSubmit}
            btnType={'submit'}
          />
        </BtnRow>
      </form>
      {props.isEmptyWarning &&
        <WarningRow>
          <Label size={'12px'} weight={'400'} color={theme.mocaRed}>
            *Email and/or password cannot be empty
          </Label>
        </WarningRow>
      }
      {props.isErrLogin &&
        <WarningRow>
          <Label size={'12px'} weight={'400'} color={theme.mocaRed}>
            {props.isErrMsg}
          </Label>
        </WarningRow>
      }
    </div>
  )
}

export default withRouter(
  withTheme(LoginForm)
)
